export default __webpack_public_path__ + "static/media/topping_wine_glass.7d21faa4.jpg";